import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]
  static values = { url: String }

  connect() {
    this.draggedItem = null
  }

  dragstart(event) {
    this.draggedItem = event.currentTarget
    event.dataTransfer.effectAllowed = "move"
    // Defer the class change so the browser captures the drag image without the faded style applied.
    setTimeout(() => this.draggedItem?.classList.add("opacity-50"), 0)
  }

  dragenter(event) {
    if (event.currentTarget !== this.draggedItem) {
      event.currentTarget.classList.add("outline", "outline-blue-400")
    }
  }

  dragover(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"
  }

  dragleave(event) {
    // dragleave bubbles from children; ignore transitions that stay within the item.
    if (event.currentTarget.contains(event.relatedTarget)) return
    event.currentTarget.classList.remove("outline", "outline-blue-400")
  }

  drop(event) {
    event.preventDefault()
    const target = event.currentTarget
    target.classList.remove("outline", "outline-blue-400")
    if (!this.draggedItem || target === this.draggedItem) return

    const items = this.itemTargets
    const draggedIndex = items.indexOf(this.draggedItem)
    const targetIndex = items.indexOf(target)

    if (draggedIndex < targetIndex) {
      target.after(this.draggedItem)
    } else {
      target.before(this.draggedItem)
    }

    this.updateStepNumbers()
    this.saveOrder()
  }

  dragend() {
    this.draggedItem?.classList.remove("opacity-50")
    this.itemTargets.forEach((item) => item.classList.remove("outline", "outline-blue-400"))
    this.draggedItem = null
  }

  updateStepNumbers() {
    this.itemTargets.forEach((item, index) => {
      const stepEl = item.querySelector("[data-step]")
      if (stepEl) stepEl.textContent = index + 1
    })
  }

  async saveOrder() {
    const orderedIds = this.itemTargets.map((item) => item.dataset.id)
    const token = document.querySelector("meta[name='csrf-token']")?.content
    if (!token) {
      console.error("reorder: CSRF token meta tag not found; aborting save")
      return
    }

    // Cancel any in-flight save so rapid drops can't settle out of order.
    this.saveAbort?.abort()
    this.saveAbort = new AbortController()

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-CSRF-Token": token, "Accept": "application/json" },
        body: JSON.stringify({ ordered_ids: orderedIds }),
        signal: this.saveAbort.signal,
      })
      if (!response.ok) {
        console.error(`reorder: server rejected save (${response.status})`)
      }
    } catch (error) {
      if (error.name === "AbortError") return
      console.error("reorder: save failed", error)
    }
  }
}
